var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNlpMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 160,
    viewBox: "0 0 109 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.091 50.9091H50.2725C48.6156 50.9091 47.2725 52.2523 47.2725 53.9091V121.444C47.2725 123.101 48.6156 124.444 50.2725 124.444H122.429C122.887 124.444 123.331 124.602 123.687 124.89L149.091 145.455V53.9091C149.091 52.2523 147.747 50.9091 146.091 50.9091Z",
    stroke: "#FF6200",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3643 76.3636H120.001",
    stroke: "#FF6200",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3643 98.1818H120.001",
    stroke: "#FF6200",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.364 48.8201V21.1818C116.364 19.5249 115.021 18.1818 113.364 18.1818H13.9097C12.2529 18.1818 10.9097 19.5249 10.9097 21.1818V98.1818L32.874 83.21C33.206 82.9837 33.5986 82.8626 34.0004 82.8626H47.2734",
    stroke: "#FF6200",
    strokeWidth: 3,
    strokeMiterlimit: 6.00562
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlpMobile);
export default __webpack_public_path__ + "static/media/nlp-mobile.f5cf0024.svg";
export { ForwardRef as ReactComponent };